// eslint-disable-next-line no-restricted-imports
import { H1 } from 'dripsy';

export default H1;
